import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { SiUpwork } from "react-icons/si";
import { UPWORK_PROFILE } from "../constants/links";

function Footer() {
  const year = new Date().getFullYear();

  const socialLinks = [
    { href: UPWORK_PROFILE, icon: <SiUpwork /> },
    { href: "https://github.com/aaftabali1", icon: <AiFillGithub /> },
    { href: "https://twitter.com/theaftabali", icon: <AiOutlineTwitter /> },
    { href: "https://www.linkedin.com/in/theaftabali/", icon: <FaLinkedinIn /> },
    { href: "https://www.instagram.com/theaftabali", icon: <AiFillInstagram /> },
  ];

  return (
    <Container fluid className="footer">
      <Row className="align-items-center">
        <Col md="4" className="footer-copywright">
          <h3>Designed & Developed by Aftab Ali</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} AA</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            {socialLinks.map((link, i) => (
              <motion.li
                key={link.href}
                className="social-icons"
                whileHover={{ y: -3 }}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
              >
                <a href={link.href} target="_blank" rel="noopener noreferrer">
                  {link.icon}
                </a>
              </motion.li>
            ))}
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
